import dayjs from "dayjs";

export default function StatusItem({ status, textTrue, textFalse, dateConfirm = '' }) {
   return (
      <div
         style={{
            display: "flex",
            fontSize: '20px',
            alignItems: "center",
            gap: "6px",
            marginBottom: "4px",
            // color: "#198754",
            color: status ? "#198754" : "#dc3545",
            marginTop: '20px',
            fontSize: '20px'
         }}
      >
         {status ? textTrue : textFalse}
         <span
            style={{
               color: status ? "#198754" : "#dc3545",
               fontWeight: "bold"
            }}
         >
            {status ? "✔" : "✖"}
         </span>

         {/* для дати */}
         {status && dateConfirm && (
            <span style={{ marginLeft: "8px", fontSize: "16px", opacity: 0.8 }}>
               {/* {dateConfirm} */}
               {/* {dayjs(dateConfirm).format("DD.MM.YYYY HH:mm")} */}
               {dayjs.utc(dateConfirm).format("DD.MM.YYYY HH:mm")}
            </span>
         )}
      </div>
   )
}